import { SvgIconBase } from '../utils/types';

export default function Community({
  width = '24',
  height = '24',
  className = 'fill-current',
}: SvgIconBase) {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="user-group">
        <path
          id="Vector"
          d="M7.50337 13.1474C7.21627 13.3013 6.93491 13.4624 6.72814 13.5903C6.23354 13.8795 5.30191 14.4241 4.62889 15.1082C4.19456 15.5497 3.6236 16.2837 3.51733 17.2933C3.48451 17.6051 3.49934 17.9036 3.55304 18.1871C3.60678 18.4709 3.63366 18.6128 3.56186 18.6872C3.49006 18.7616 3.37042 18.7434 3.13114 18.707C2.10732 18.5512 1.41543 17.9931 0.847642 17.3845C0.423078 16.9295 0.203787 16.4061 0.258175 15.8464C0.30924 15.3208 0.59019 14.8976 0.871177 14.5882C1.31466 14.0998 1.96834 13.686 2.35981 13.4381C2.44345 13.3852 2.51514 13.3398 2.57023 13.3029C4.04765 12.3132 5.8097 12.0212 7.45505 12.427C7.84296 12.5226 8.03691 12.5704 8.05406 12.7068C8.0712 12.8431 7.88193 12.9445 7.50337 13.1474Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          id="Vector_2"
          d="M6.48741 5.28631C6.67712 5.31484 6.77197 5.3291 6.8207 5.4079C6.86944 5.48671 6.83547 5.59136 6.76754 5.80068C6.59386 6.33583 6.5 6.90695 6.5 7.5C6.5 8.73995 6.91032 9.88407 7.60259 10.804C7.73465 10.9795 7.80068 11.0672 7.78033 11.1575C7.75999 11.2478 7.67509 11.2922 7.5053 11.3811C7.05526 11.6167 6.5432 11.75 6 11.75C4.20507 11.75 2.75 10.2949 2.75 8.5C2.75 6.70507 4.20507 5.25 6 5.25C6.16566 5.25 6.32842 5.26239 6.48741 5.28631Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          id="Vector_3"
          d="M16.4971 13.1474C16.7842 13.3013 17.0655 13.4624 17.2723 13.5903C17.7669 13.8795 18.6985 14.4241 19.3715 15.1082C19.8059 15.5497 20.3768 16.2837 20.4831 17.2933C20.5159 17.6051 20.5011 17.9036 20.4474 18.1871C20.3937 18.4709 20.3668 18.6128 20.4386 18.6872C20.5104 18.7616 20.63 18.7434 20.8693 18.707C21.8931 18.5512 22.585 17.9931 23.1528 17.3845C23.5774 16.9295 23.7967 16.4061 23.7423 15.8464C23.6912 15.3208 23.4102 14.8976 23.1293 14.5882C22.6858 14.0998 22.0321 13.686 21.6406 13.4381C21.557 13.3852 21.4853 13.3398 21.4302 13.3029C19.9528 12.3132 18.1907 12.0212 16.5454 12.427C16.1575 12.5226 15.9635 12.5704 15.9464 12.7068C15.9292 12.8431 16.1185 12.9445 16.4971 13.1474Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          id="Vector_4"
          d="M16.3982 10.804C16.2661 10.9795 16.2001 11.0672 16.2204 11.1575C16.2408 11.2478 16.3257 11.2922 16.4954 11.3811C16.9455 11.6167 17.4576 11.75 18.0007 11.75C19.7957 11.75 21.2507 10.2949 21.2507 8.5C21.2507 6.70507 19.7957 5.25 18.0007 5.25C17.8351 5.25 17.6723 5.26239 17.5133 5.28631C17.3236 5.31484 17.2288 5.3291 17.18 5.4079C17.1313 5.48671 17.1653 5.59136 17.2332 5.80068C17.4069 6.33583 17.5007 6.90695 17.5007 7.5C17.5007 8.73995 17.0904 9.88407 16.3982 10.804Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          id="Vector_5"
          d="M7.69146 14.4733C10.3292 12.8422 13.675 12.8422 16.3127 14.4733C16.3905 14.5214 16.489 14.579 16.6022 14.6452C17.1145 14.945 17.9276 15.4208 18.4826 15.9849C18.8311 16.3391 19.1787 16.8221 19.242 17.4242C19.3099 18.0683 19.0365 18.6646 18.5149 19.1806C17.6533 20.033 16.5859 20.75 15.1865 20.75H8.81773C7.41827 20.75 6.35094 20.033 5.48932 19.1806C4.96775 18.6646 4.69435 18.0683 4.76215 17.4242C4.82553 16.8221 5.17313 16.3391 5.52165 15.9849C6.07655 15.4208 6.88974 14.945 7.40201 14.6452C7.51518 14.579 7.6137 14.5214 7.69146 14.4733Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          id="Vector_6"
          d="M7.75195 7.5C7.75195 5.15279 9.65474 3.25 12.002 3.25C14.3492 3.25 16.252 5.15279 16.252 7.5C16.252 9.84721 14.3492 11.75 12.002 11.75C9.65474 11.75 7.75195 9.84721 7.75195 7.5Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
      </g>
    </svg>
  );
}
